<div class="container-fluid px-1 px-md-5 px-lg-1 px-xl-5 py-5 mx-auto">
    <div class="card card0 border-0">
        <div class="row d-flex">
            <div class="col-lg-6">
                <div class="card1 pb-5">
                    <div class="row"> <img src="../../../assets/images/logoa.svg"
                            style="width: 90%; margin: auto; padding-top: 20px;"> </div>
                    <div class="row px-3 justify-content-center mt-4 mb-5 border-line"> <img
                            src="../../../assets/images/logo-mini.svg" class="image"> </div>
                </div>
            </div>

            <div class="col-lg-6" style="margin: auto;">
                <!-- Email Request Form -->
                <form #ngLoginForm="ngForm" *ngIf="!isLoggedIn && loginPage" name="form" (ngSubmit)="ngLoginForm.form.valid && getCode()" novalidate>
                    <div class="card2 card border-0 px-4 py-5">
                        <div class="row mb-4">
                            <div class="col-12 text-center">
                                <h4 class="mb-2">HR Requisition Portal</h4>
                                <p class="text-muted">Enter your email to receive a verification code</p>
                            </div>
                        </div>
                        
                        <div class="row px-3">
                            <div class="col-12">
                                <label class="mb-2">
                                    <h6 class="mb-0 text-sm">Email Address</h6>
                                </label>
                                <input
                                    type="email"
                                    class="form-control mb-2"
                                    name="email"
                                    [(ngModel)]="loginRequest.email"
                                    required
                                    email
                                    #email="ngModel"
                                    placeholder="Enter a valid email address"
                                />
                                <div class="alert alert-danger mt-2" role="alert" *ngIf="ngLoginForm.submitted && email.errors">
                                    <div *ngIf="email.errors['required']">Email is required!</div>
                                    <div *ngIf="email.errors['email']">Please enter a valid email address!</div>
                                </div>
                            </div>
                        </div>

                        <div class="row px-3 mt-4">
                            <div class="col-12">
                                <button 
                                    type="submit" 
                                    class="btn btn-blue text-center w-100 mb-3" 
                                    [disabled]="isSubmitting">
                                    <span *ngIf="!isSubmitting || (isLoggingInAs && isSubmitting)">Request Code</span>
                                    <span *ngIf="isSubmitting && !isLoggingInAs">
                                        <i class="fa fa-spinner fa-spin"></i> Sending...
                                    </span>
                                </button>
                                 <button 
                                    type="button" 
                                    *ngIf="isAvailable"
                                    class="btn btn-outline-secondary text-center w-100" 
                                    (click)="loginAs()"
                                    [disabled]="isSubmitting">
                                    <span *ngIf="(isSubmitting && !isLoggingInAs) || (!isSubmitting && !isLoggingInAs)">
                                        <i class="fa fa-user mr-2"></i> Login as {{cachedName}}
                                    </span>
                                    <span *ngIf="isSubmitting && isLoggingInAs">
                                        <i class="fa fa-spinner fa-spin"></i> Logging in as {{cachedName}}...
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

                <!-- Verification Code Form -->
                <form #ngResetForm="ngForm" *ngIf="!isLoggedIn && !loginPage" name="form" (ngSubmit)="ngResetForm.form.valid && verifyCode()" novalidate>
                    <div class="card2 card border-0 px-4 py-5">
                        <div class="row mb-4">
                            <div class="col-12 text-center">
                                <h4 class="mb-2">Verify Your Code</h4>
                                <p class="text-muted">Enter the verification code sent to your email</p>
                                <p class="text-sm text-primary">{{ loginRequest.email }}</p>
                            </div>
                        </div>

                        <div class="row px-3">
                            <div class="col-12">
                                <label class="mb-2">
                                    <h6 class="mb-0 text-sm">Verification Code</h6>
                                </label>
                                <input
                                    type="text"
                                    class="form-control mb-2"
                                    name="code"
                                    [(ngModel)]="loginRequest.code"
                                    required
                                    #code="ngModel"
                                    placeholder="Enter the verification code"
                                    maxlength="6"
                                />
                                <div class="alert alert-danger mt-2" role="alert" *ngIf="ngResetForm.submitted && code.errors">
                                    Verification code is required!
                                </div>
                            </div>
                        </div>

                        <div class="row px-3 mt-4">
                            <div class="col-12">
                                <button 
                                    type="submit" 
                                    class="btn btn-blue text-center w-100 mb-3" 
                                    [disabled]="isSubmitting">
                                    <span *ngIf="!isSubmitting">Verify Code</span>
                                    <span *ngIf="isSubmitting">
                                        <i class="fa fa-spinner fa-spin"></i> Verifying...
                                    </span>
                                </button>
                                <button 
                                    type="button" 
                                    class="btn btn-outline-secondary text-center w-100" 
                                    (click)="toggleFormBack()"
                                    [disabled]="isSubmitting">
                                    <i class="fa fa-arrow-left mr-2"></i> Back to Email
                                </button>
                            </div>
                        </div>

                        <div class="row px-3 mt-3">
                            <div class="col-12 text-center">
                                <small class="text-muted">
                                    Didn't receive the code? 
                                    <a href="javascript:void(0)" (click)="toggleFormBack()" class="text-primary">Resend</a>
                                </small>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <br>
        <div class="bg-blue py-4">
            <div class="row px-3"> 
                <small class="ml-4 ml-sm-5 mb-2">Copyright &copy; HBM Nigeria Plc {{ today | date : 'yyyy'}}. All rights reserved.</small>
                <div class="social-contact ml-4 ml-sm-auto"> 
                    <span class="fa fa-facebook mr-4 text-sm"></span> 
                    <span class="fa fa-google-plus mr-4 text-sm"></span> 
                    <span class="fa fa-linkedin mr-4 text-sm"></span>
                    <span class="fa fa-twitter mr-4 mr-sm-5 text-sm">
                        <img src="../../../assets/images/holcim_logo_color.svg" alt="" srcset="" style="height: 30px;">
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>